import axios from 'axios'

const instance = axios.create({ timeout: 1000 * 20 })

const errorHandle = message => {
  alert(message)
}

// 取消重复请求
const pending = []
const cancelToken = axios.CancelToken
const removePending = (config) => {
  pending.forEach((item, index) => {
    if(item.requestFlag === config.url + '&' + config.method) {
      item.cancel('取消重复请求！')
      pending.splice(index, 1)
    }
  })
}

// http request 拦截器
instance.interceptors.request.use( 
  config => {
    removePending(config)
    config.cancelToken = new cancelToken( cancel => {
      const requestFlag = config.url + '&' + config.method
      pending.push({requestFlag, cancel})
    })
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// http response 拦截器
instance.interceptors.response.use(
  response => {
    if ( response.status >= 200 && response.status < 400 ) {
      return Promise.resolve(response.data)
    }
  },
  error => {
    if (error && error.response) {
      if( error.response.status >= 400 && error.response.status < 500 ) {
        errorHandle('请求错误！')
        return Promise.reject(error.message)
      }
      else if( error.response.status >= 500) {
        errorHandle('服务器错误！')
        return Promise.reject(error.message)
      }
      else {
        errorHandle('服务器遇到未知错误！')
        return Promise.reject(error.message)
      }
    }
    else {
      // 不提示错误，静默处理
      if(error.message === '取消重复请求！') return Promise.reject(error)
      else {
        errorHandle('连接到服务器失败 或 服务器响应超时！')
        return Promise.reject(error)
      }
    }
  }
)

export default instance